import { PropsWithChildren, useCallback, useMemo, useState } from "react";
import { KeysysToastProps } from "../../component-library";
import { IToastContext, ToastContext } from ".";
import { getErrorWithMessage } from "../../helper-functions";

export const ToastProvider = (props: PropsWithChildren) => {
    const [activeToasts, setActiveToasts] = useState<KeysysToastProps[]>([]);

    const showToast = useCallback((toastProps: KeysysToastProps) => {
        setActiveToasts((current) => [...current, toastProps]);
    }, []);

    const hideToast = useCallback((name: string) => {
        setActiveToasts((current) => [...current.filter((t) => t.name !== name)]);
    }, []);

    const errorToast = useCallback(
        (error: unknown) => {
            if (!error) return;
            const { message } = getErrorWithMessage(error);
            if (!message?.trim()) return;

            showToast({
                name: `Error ${Date.now()}`,
                theme: "danger",
                titleInHeader: "Error",
                body: message,
                delay: 5000,
            });
        },
        [showToast]
    );

    const value = useMemo<IToastContext>(
        () => ({
            activeToasts,
            showToast,
            hideToast,
            errorToast,
        }),
        [activeToasts, showToast, hideToast, errorToast]
    );

    return <ToastContext.Provider value={value} {...props} />;
};
